export const requestData = ( url, callback ) => {
	fetch( url, {
		method: 'GET',
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
	} )
		.then( ( response ) => response.json() )
		.then( callback );
};
